<template>
  <b-nav-item-dropdown text="Publications">
    <b-dropdown-item @click="goTo({ name: 'issueDetail', params: { volumeId: 1, issueId: 1 }})">Current Issue</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'advanceOnlinePublications' })">Advance Online Publications</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'archivedIssues' })">Archived Issues</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'collections' })">Collections</b-dropdown-item>
    <b-dropdown-item @click="goTo({ name: 'videos' })">Videos</b-dropdown-item>
    <b-dropdown-item @click="goTo({name: 'authorInterviews'})">Author Interviews</b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
  export default {
    name: 'publications-dropdown',
    methods: {
      goTo (rO) {
        this.$router.push(rO)
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// PublicationsDropdownComponent.vue?64a5b094